// extracted by mini-css-extract-plugin
export default {"termsAndConditionsContainer":"termsAndConditions_termsAndConditionsContainer__4xouz","termsAndConditions":"termsAndConditions_termsAndConditions__HLyqP"};